import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTimeline',
  setup(__props) {

const basicTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/basicTimeline.vue"))
const hoveringTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/hoveringTimeline.vue"))
const variationTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/variationTimeline.vue"))
const horizontalTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/horizontalTimeline.vue"))
const timelineView = defineAsyncComponent(() => import("@/components/theme/advance/timeline/timelineView.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Timeline",
      title: "Timeline"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicTimeline)),
        _createVNode(_unref(hoveringTimeline)),
        _createVNode(_unref(variationTimeline)),
        _createVNode(_unref(horizontalTimeline)),
        _createVNode(_unref(timelineView))
      ])
    ])
  ], 64))
}
}

})